import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'additionalInfoDisplay',
  pure: true
})
export class AdditionalInfoDisplayPipe implements PipeTransform {
  transform(additionalInformation: string | null | undefined): string {
    return additionalInformation ? `Additional information: ${additionalInformation}` : '';
  }
}
